import { EntityService } from './EntityService';
import { ICorporateRiskRiskMitigationAction} from '../types';

export class CorporateRiskRiskMitigationActionService extends EntityService<ICorporateRiskRiskMitigationAction> {
    constructor() {
        super('/CorporateRiskRiskMitigationActions');
    }
}